// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelfServiceSignUpWithEmailMutationVariables = Types.Exact<{
  input: Types.SelfServiceSignUpWithEmailInput;
}>;


export type SelfServiceSignUpWithEmailMutation = { __typename?: 'Mutation', selfServiceSignUpWithEmail: { __typename?: 'AuthResult', accessToken: string } };


export const SelfServiceSignUpWithEmailDocument = /*#__PURE__*/ gql`
    mutation SelfServiceSignUpWithEmail($input: SelfServiceSignUpWithEmailInput!) {
  selfServiceSignUpWithEmail(input: $input) {
    accessToken
  }
}
    `;

/**
 * __useSelfServiceSignUpWithEmailMutation__
 *
 * To run a mutation, you first call `useSelfServiceSignUpWithEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceSignUpWithEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfServiceSignUpWithEmailMutation, { data, loading, error }] = useSelfServiceSignUpWithEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfServiceSignUpWithEmailMutation(baseOptions?: Apollo.MutationHookOptions<SelfServiceSignUpWithEmailMutation, SelfServiceSignUpWithEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfServiceSignUpWithEmailMutation, SelfServiceSignUpWithEmailMutationVariables>(SelfServiceSignUpWithEmailDocument, options);
      }
export type SelfServiceSignUpWithEmailMutationHookResult = ReturnType<typeof useSelfServiceSignUpWithEmailMutation>;